import { useState } from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import { FishSolidV6, UserSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";

const TimelineLeadCreateEvent = ({ event, event: { timeline_fields: timelineFields } }) => {
  const [showModal, setShowModal] = useState(false);
  const isPondToPond = timelineFields.new_lead_pond && timelineFields.old_lead_pond;
  const isAgentToPond = timelineFields.old_primary_agent && timelineFields.new_lead_pond;

  const headline = (
    <div>
      {isPondToPond || isAgentToPond ? "Assigned to " : ""}
      <span className="tw-font-semibold">
        {timelineFields.new_primary_agent}
        {timelineFields.new_lead_pond}
      </span>
      {!isPondToPond && !isAgentToPond ? " became the primary agent" : ""}
      {isAgentToPond ? " by " : ""}
      <span className="tw-font-semibold">{isAgentToPond ? timelineFields.transferred_by : ""}</span>
    </div>
  );

  const description = (
    <div>
      {"Transferred by "}
      <span className="tw-font-semibold">{timelineFields.transferred_by}</span>
      {" from "}
      <span className="tw-font-semibold">
        {timelineFields.old_primary_agent} {timelineFields.old_lead_pond}
      </span>
    </div>
  );

  return (
    <BaseEvent
      title={headline}
      icon={timelineFields.old_lead_pond || timelineFields.new_lead_pond ? <FishSolidV6 /> : <UserSolidV6 />}
      interactedAt={event.interacted_at_absolute}
      onClick={() => setShowModal(true)}
    >
      {description}
      <Modal
        dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
        contentClassName="tw-max-w-[480px] tw-max-h-[90vh] tw-w-full tw-flex tw-flex-col tw-gap-[32px]"
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header title="Lead Transferred" closeButton />
        <Modal.Body>
          {headline}
          <div className="tw-font-semibold tw-mt-[8px]">Details:</div>
          {description}
        </Modal.Body>
      </Modal>
    </BaseEvent>
  );
};

TimelineLeadCreateEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default TimelineLeadCreateEvent;
